import { faTrash } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import ReactTable from "react-table";
import { TabPane } from "reactstrap";
import BaseButtonWithIconAndTooltip from "../../../toolkit/baseButtonWithIconAndTooltip";
import { userHasPermission } from "../../../utils/accessTree";
import { handleRequestError } from "../../../utils/helpers";
import {
  infoNotification,
  successNotification
} from "../../../utils/notifications";
import permissionCodes from "../../../utils/permissionCodes";
import {
  deleteDirectDiscount,
  getDirectIdMembresiaSocio
} from "../../actions/dicounts";
import { Partner } from "./interfaces";

interface Props {
  partner: Partner;
  activeTab: string;
}

interface State {
  descuentos: any[];
  wait: boolean;
}

export default class TabDescuentosDirectos extends React.Component<
  Props,
  State
> {
  state = {
    descuentos: [],
    wait: false
  };

  columns = [
    {
      Header: "Club",
      id: "club",
      accessor: "club",
      width: "128"
    },
    {
      Header: "Membresía",
      id: "idPublico",
      accessor: "idPublico",
      width: "88"
    },
    {
      Header: "Fecha beneficio",
      id: "fechaBeneficio",
      accessor: "fechaBeneficio",
      width: "120"
    },
    {
      Header: "Tipo beneficio",
      id: "tipo",
      accessor: "tipo",
      width: "104"
    },
    {
      Header: "Valor",
      id: "valor",
      accessor: "valor",
      width: "64"
    },
    {
      Header: "Estatus",
      id: "estatus",
      accessor: "estatus",
      width: "96"
    },
    {
      Header: "Fecha aplicación",
      id: "fechaAplicacion",
      accessor: "fechaAplicacion",
      width: "120"
    },
    {
      Header: "Usuario",
      id: "usuario",
      accessor: "usuario",
      width: "120"
    },
    {
      Header: "Tipo descuento",
      id: "tipoDescuento",
      accessor: "tipoDescuento",
      width: "120"
    },
    {
      Header: "Observaciones",
      id: "observaciones",
      accessor: "observaciones",
      width: "512"
    },
    {
      Header: "",
      width: "100",
      maxWidth: "100",
      Cell: row => {
        const { idDescuento } = row.original;

        return (
          <div>
            {" "}
            {userHasPermission(
              permissionCodes.PARTNER_MEMBERSHIP_TAB_DIRECT_DISCOUNTS_DELETE
            ) && (
              <BaseButtonWithIconAndTooltip
                id={`deleteDirectDiscount_${idDescuento}`}
                icon={faTrash}
                tooltipTitle="Eliminar descuento directo"
                onClick={() => {
                  infoNotification("Eliminando descuento directo...");

                  deleteDirectDiscount(
                    this.props.partner.idMembresiaSocio,
                    idDescuento
                  )
                    .then(() => {
                      successNotification(
                        "Descuento directo eliminado correctamente"
                      );
                      this.getDirectDiscounts();
                    })
                    .catch(handleRequestError);
                }}
              />
            )}
          </div>
        );
      }
    }
  ];

  componentDidUpdate(prevProps) {
    if (prevProps.activeTab != this.props.activeTab) {
      if (this.props.activeTab == "19") {
        this.setState({
          wait: true
        });
        this.getDirectDiscounts();
      } else {
        this.setState({
          descuentos: [],
          wait: false
        });
      }
    }
  }

  getDirectDiscounts = () => {
    getDirectIdMembresiaSocio(this.props.partner.idMembresiaSocio)
      .then(response => {
        this.setState({
          descuentos: response.data,
          wait: false
        });
      })
      .catch(err => {
        this.setState({
          descuentos: [],
          wait: false
        });
      });
  };

  render() {
    if (this.props.activeTab != "19") {
      return <></>;
    }

    return (
      <TabPane className="my-2" tabId="19">
        <div>
          <ReactTable
            className="mt-5 -striped -highlight"
            data={this.state.descuentos || []}
            columns={this.columns}
            sortable={false}
            resizable={true}
            pageSize={
              this.state.descuentos && this.state.descuentos.length > 5
                ? this.state.descuentos.length
                : 5
            }
            showPagination={false}
            loading={this.state.wait}
          />
        </div>
      </TabPane>
    );
  }
}
